import {Pipe, PipeTransform} from '@angular/core';
import {formatDuration} from '../utils/duration.util';

@Pipe({
  name: 'trackerMetricValue',
  standalone: true,
})
export class TrackerMetricValuePipe implements PipeTransform {
  transform(value: string | number, type: string): unknown {
    if (type === 'boolean') {
      const v = Number(value);
      return v >= 1 ? 'Yes' : 'No';
    }
    if (type === 'duration') {
      return formatDuration(Number(value));
    }

    return value;
  }
}
